// extracted by mini-css-extract-plugin
export default {"switchCheckbox":"Switch_switchCheckbox__ITO-L","switchLabel":"Switch_switchLabel__dE-QR","switchButton":"Switch_switchButton__RHd0Z"};